export default __webpack_public_path__ + "static/media/My Profile.909997ea.svg";